/**
 * @generated SignedSource<<decb68287451f7e62c3bf7554539d57f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageDetail_package$data = {
  readonly id: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PackageBenefitsSummary_package" | "StorePackageSummary_package">;
  readonly " $fragmentType": "StorePackageDetail_package";
};
export type StorePackageDetail_package$key = {
  readonly " $data"?: StorePackageDetail_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageDetail_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageDetail_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageBenefitsSummary_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorePackageSummary_package"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "8edfaa1eadd58cbe9c9423322eddc674";

export default node;
